import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import InnerLayout from "../innerLayout/InnerLayout";
import "./Media.css";
import { deleteMedia, getMediaCategories, getMediaPlayout, getMediaWithPagination, HiveStackRequest, MediaCategory, MediaContentType, MediaContentTypeOption, mediaContentTypeOptions, MediaModel, MediaPlayout, MediaPlayoutRequest, MediaType, MediaVastRequest as MediaVastRequest, postHiveStack, postMediaVast, postWebPage, postWebPageWithZip, postYoutubeMedia, updateHiveStack, updateMedia,  updateMediaVast,  updateWebPage,  uploadMedia, WebPageRequest, WebPageType, YoutubeMediaRequest } from "../../../api/mediaApi";
import { formatDate } from "../../../services/dateService";
import { SelectMultipleFileButton } from "../../components/selectFileButton/SelectFileButton";
import Search from "../../components/search/Search";
import IconButton from "../../components/iconButton/IconButton";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import { CenterModal, RightModal, SmallModal } from "../../components/sideModal/Modal";
import FileInfo from "../../components/fileInfo/FileInfo";
import { Button } from "../../components/Button";
import { FormInput, FormInputNumber, FormRow } from "../../components/formRow/FormRow";
import SvgSelector from "../../components/svgSelector/SvgSelector";
import { getCampaignsBase } from "../../../api/campaingsApi";
import { Guid } from "../../../api/baseApi";
import Select, { MultiValue, SingleValue } from "react-select";
import { sunbScribeOnClick, unsubscribe } from "../../../services/globalEventHandler";
import DropdownBlock from "../../components/dropdown/dropdownBlock";
import moment, { Moment } from "moment";
import FormCheckbox from "../../components/formRow/FormCheckbox";
import Pagination from "../../components/pagination/Pagination";
import MediaTranscodeModal from "../../components/mediaTranscodeModal/MediaTranscodeModal";
import hiveStackIMG from './../../images/icons/hivestack.jpg';

type Option<T> = { value: T, label: string} 

enum FilterDatesType {
    All = 1,
    Today = 2,
    Yesterday = 3,
    Last7Days = 4,
    Last30Days = 5
}

export interface MediaProps  extends RouteComponentProps<any>
{
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;

}

export type MediaState = 
{
    media : MediaModel[],
    campaigns: Option<Guid>[],
    selectedCampaigns: Guid[],

    isUploading: boolean
    showMediaInfoModal: boolean,
    mediaInfo?: MediaModel,
    showVASTModal :boolean,
    vastIdForUpdate: Guid,
    vastName: string,
    isVastNameError: boolean,
    vastUrl: string
    isVastUrlError: boolean,
    clockId: string,
    searchString: string,
    currentPage: number,
    totalPages: number,

    periodStart?: Moment,
    periodEnd?: Moment,
    isPeriodStartError: boolean,
    isPeriodEndError: boolean,
    isDatefilterDropdownShow: boolean,
    currentFilterPeriod: FilterDatesType | '',

    newMediaName: string,
    newDurationMs: string,
    showMediaDeleteModal: boolean,
    mediaIdForAction: Guid,
    mediaNameForDelete: string,

    showYoutubeModal:boolean,
    youtubeName: string,
    isYoutubeNameError: boolean,
    youtubeUrl: string,
    isYoutubeUrlError: boolean,
    isLiveYoutube: boolean,
    youtubeDuration: string | number,

    selectedContentTypeOption: SingleValue<MediaContentTypeOption>,

    showWebPageModal:boolean,
    webPageIdForUpdate: Guid,
    webPageName: string,
    isWebPageNameError: boolean,
    webPageUrl: string,
    isWebPageUrlError: boolean,
    webPageDuration: string | number,
    webPageClockId: string,

    selectedWebPageContentTypeOption: SingleValue<MediaContentTypeOption>,

    showHiveStackModal:boolean,
    hiveStackIdForUpdate: Guid,
    hiveStackName: string,
    isHiveStackNameError: boolean,
    hiveStackClockId: string,

    selectedHiveStackContentTypeOption: SingleValue<MediaContentTypeOption>,

    idsForPlayouts: Guid[],
    playouts: MediaPlayout[],

    isShowTranscodeModal: boolean,

    isLocal: boolean,
    zipFile: File | null,
    isWebPageZipError: boolean,
    selectedWebPageType: WebPageType,

    mediaCategories: Option<number>[],
    selectedMediaCategory: SingleValue<Option<number>>
}

class Media extends React.Component<MediaProps, MediaState> {
    constructor(props: MediaProps) {
        super(props);
        this.state = {
            media: [],
            campaigns: [],
            selectedCampaigns: [],
            isUploading: false,
            showMediaInfoModal: false,
            showVASTModal: false,
            vastIdForUpdate: '',
            vastName: '',
            isVastNameError: false,
            vastUrl: '',
            isVastUrlError: false,
            clockId: '',
            searchString: '',
            currentPage: 1,
            totalPages: 1,

            isPeriodStartError: false,
            isPeriodEndError: false,
            isDatefilterDropdownShow: false,
            currentFilterPeriod: '',

            newMediaName: '',
            newDurationMs: '10',
            showMediaDeleteModal: false,
            mediaIdForAction: '',
            mediaNameForDelete: '',

            showYoutubeModal: false,
            youtubeName: '',
            isYoutubeNameError: false,
            youtubeUrl: '',
            isYoutubeUrlError: false,
            isLiveYoutube: false,
            youtubeDuration: 15,

            selectedContentTypeOption: mediaContentTypeOptions[0],

            showWebPageModal:false,
            webPageIdForUpdate:'',
            webPageName: '',
            isWebPageNameError: false,
            webPageUrl: '',
            isWebPageUrlError: false,
            webPageDuration: 15,
            webPageClockId:'',

            selectedWebPageContentTypeOption: mediaContentTypeOptions[0],

            showHiveStackModal:false,
            hiveStackIdForUpdate:'',
            hiveStackName: '',
            isHiveStackNameError: false,
            hiveStackClockId:'',

            selectedHiveStackContentTypeOption: mediaContentTypeOptions[0],

            idsForPlayouts:[],
            playouts: [],
            
            isShowTranscodeModal: false,

            isLocal: true,
            zipFile: null,
            isWebPageZipError: false,
            selectedWebPageType: WebPageType.URL,

            mediaCategories: [],
            selectedMediaCategory: null,
        };
        
        this.onFileChange = this.onFileChange.bind(this);
        this.updateMediaList = this.updateMediaList.bind(this);
    }

    debounceTimer: NodeJS.Timeout | null = null; 

    mediaItemsPerPage = 20;

    override async componentWillMount(){

        await Promise.all([this.updateMediaList(),this.updateCampaignsBaseOptions(), this.updateMediaCategories()])

        sunbScribeOnClick(()=>{
            this.hideDatefilterDropdown();
        }, "mediaDateFilter")
    }

    override async componentDidUpdate(prevProps:MediaProps, prevState: MediaState) {
        if (
            prevState.selectedCampaigns !== this.state.selectedCampaigns ||
            prevState.periodStart !== this.state.periodStart ||
            prevState.periodEnd !== this.state.periodEnd) {
            await this.updateMediaList()
        }
        if (prevState.searchString !== this.state.searchString) {
            if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = setTimeout(async () => {
                await this.updateMediaList()
            }, 1000);
        }
      }

    override async componentWillUnmount(){
        unsubscribe("mediaDateFilter");
    }

    setIsUploading = (isUploading: boolean) =>  this.setState({isUploading: isUploading});

    onChangeSelectedCampaigns = (values: MultiValue<Option<Guid>>) => {
        this.setState({
            selectedCampaigns: values.map(it => it.value), 
            currentPage:1
        })
    }

    onSelectedMediaLabel = (newValue: SingleValue<MediaContentTypeOption>) => {
        this.setState({ selectedContentTypeOption: newValue})
    }

    async updateMediaList( currentPage?: number){
        this.setState({isUploading:true})
        var getMediaResult = await getMediaWithPagination({
            campaignId: [...this.state.selectedCampaigns],
            searchString: this.state.searchString,
            startTime: this.state.periodStart ? this.state.periodStart.toISOString() : null,
            endTime: this.state.periodEnd ? this.state.periodEnd.toISOString() : null,
            pageNumber: currentPage ? currentPage : this.state.currentPage,
            itemsPerPage: this.mediaItemsPerPage
        });
        
        if(getMediaResult.type === "succes"){
            this.setState({
                media: getMediaResult.data.items.filter(it => it.isDeleted != true),
                totalPages: getMediaResult.data.totalPages
            })
        }
        await this.updateMediaPlayouts();
        this.setState({isUploading:false})
    }

    async updateCampaignsBaseOptions(){
        let campaignsResult = await getCampaignsBase();
        if(campaignsResult.type == "succes") {
            this.setState({campaigns: campaignsResult.data.items.map(it => {
                return {value: it.id, label: it.name}
                })
            }); 
        }
    }

    async updateMediaPlayouts(mediaIds: Guid[] = []){
        let mediaIdsForPlayouts
        if(!mediaIds.length){
            // mediaIdsForPlayouts = getPage<MediaModel>(this.state.media, this.state.currentPage, this.mediaItemsPerPage).map(it => it.id);
            mediaIdsForPlayouts = this.state.media.map(it => it.id);
        } else { mediaIdsForPlayouts = mediaIds }
        let playoutRequest:MediaPlayoutRequest = {
            ids: mediaIdsForPlayouts,
            playerId: null
        }
        let playoutResponse = await getMediaPlayout(playoutRequest);
        if(playoutResponse.type === "succes"){
            this.setState({playouts: playoutResponse.data.items})
        }
    }

    async updateMediaCategories() {
        let result = await getMediaCategories();
        if(result.type == "succes") {
            this.setState({mediaCategories: result.data.items.map(it => {
                return {value: it.id, label: it.name}
                })
            }); 
        }
    }

    setSearchString = (search: string) => {
        this.setState({
            searchString: search,
            currentPage: 1
        })
    }

    checkCurrentFilterPeriod = (filterPeriod: FilterDatesType) => {
        return filterPeriod === this.state.currentFilterPeriod
    }

    setFilterPeriod = (filterPeriod: FilterDatesType) => {
        switch(filterPeriod) {
            case FilterDatesType.All : {
                this.setState({
                    periodStart : undefined,
                    periodEnd : undefined,
                    currentFilterPeriod: FilterDatesType.All,
                    currentPage:1
                }); break;
            }
            case FilterDatesType.Today : {
                this.setState({
                    periodStart : moment().startOf("date"),
                    periodEnd : moment().startOf("date"),
                    currentFilterPeriod: FilterDatesType.Today,
                    currentPage:1
                }); break;
            }
            case FilterDatesType.Yesterday : {
                this.setState({
                    periodStart : moment().startOf("date").add(-1,'day'),
                    periodEnd :  moment().startOf("date").add(-1,'day'),
                    currentFilterPeriod: FilterDatesType.Yesterday,
                    currentPage:1
                }); break;
            }
            case FilterDatesType.Last7Days : {
                this.setState({
                    periodStart : moment().startOf("date").add(-7,'day'),
                    periodEnd :  moment().startOf("date"),
                    currentFilterPeriod: FilterDatesType.Last7Days,
                    currentPage:1
                }); break;
            }
            case FilterDatesType.Last30Days : {             
                this.setState({
                    periodStart : moment().startOf("date").add(-30,'day'),
                    periodEnd :  moment().startOf("date"),
                    currentFilterPeriod: FilterDatesType.Last30Days
                }); break;
            }
        }
    }


    changePaginationPage = async (currentPage: number) => {
        this.setState({currentPage: currentPage})
        await this.updateMediaList(currentPage)
    }

    async onFileChange(event: React.ChangeEvent<HTMLInputElement>): Promise<void>{
        if(event.target.files){
            const formData = new FormData();
            this.setState({isUploading : true})
            formData.append("Media", event.target.files[0] )
            var res = await uploadMedia(formData);
            await this.updateMediaList();
            this.setState({isUploading : false})
        }
    }

    setUpdateName = (newName: string) => this.setState({newMediaName: newName});
    setUpdateDuration = (newDuration: string) => this.setState({newDurationMs: newDuration});

    onUpdateMediaInfo = async (id: string, newName: string, newDuration: number, mediaType: MediaType, contentType : MediaContentType | null, clockID: string, mediaCategoryId:number | null)=>{
            this.setState({isUploading: true})
            mediaType === MediaType.Image ? (
                await updateMedia(id,{newName: newName, newDurationMs: newDuration, contentType: contentType, clockID: clockID, taxonomiesCategoryId: mediaCategoryId})
            ):(
                await updateMedia(id,{newName: newName, contentType: contentType, clockID: clockID,taxonomiesCategoryId: mediaCategoryId})
            )
            await this.updateMediaList();
            this.setState({isUploading: false, newMediaName: '', showMediaInfoModal: false});
    }
    
    closeMediaInfoModal = () => { 
        let video = document.querySelector('video');
        video?.pause();
        video && (video.currentTime = 0);
        this.setState({showMediaInfoModal: false})
    };

    closeVASTModal = () => { 
        this.setState({
            showVASTModal: false,
            vastIdForUpdate: '',
            vastName: '',
            isVastNameError:false,
            vastUrl: '',
            isVastUrlError: false,
            selectedContentTypeOption: mediaContentTypeOptions[0],
            clockId: '',
            selectedMediaCategory: null
        })
    };

    showMediaInfoModal = (mediaInfo: MediaModel) => { this.setState({mediaInfo: mediaInfo, showMediaInfoModal: true})};
    showVASTModal = () => { this.setState({showVASTModal: true})};

    showEditVastModal = (vast: MediaModel) => {
        this.setState({
            showVASTModal: true,
            vastIdForUpdate: vast.id,
            vastName: vast.name,
            vastUrl: vast.vastUrl,
            selectedContentTypeOption: mediaContentTypeOptions.filter(it => it.type === vast.contentType)[0],
            clockId: vast.clockId,
            selectedMediaCategory: this.getCategoryById(vast.taxonomiesCategoryId)
        })
    }
    
    setVastName = (newName: string) => { this.setState({vastName: newName, isVastNameError: false})}
    setVastUrl = (newUrl: string) => { this.setState({vastUrl: newUrl, isVastUrlError: false})}
    setClockID = (newID: string) => { this.setState({clockId: newID})}
    
    showYoutubeModal = () => { this.setState({showYoutubeModal: true})};
    closeYoutubeModal = () => { 
        this.setState({
            showYoutubeModal: false, 
            isYoutubeNameError:false, 
            isYoutubeUrlError: false,
            youtubeName: "",
            youtubeUrl:"",
            isLiveYoutube: false,
            youtubeDuration: 15,
            selectedMediaCategory: null
        })
    };
    setYoutubeName = (newName: string) => { this.setState({youtubeName: newName, isYoutubeNameError: false})}
    setYoutubeUrl = (newUrl: string) => { this.setState({youtubeUrl: newUrl, isYoutubeUrlError: false})}
    setYoutubeLive = (isLive: boolean) => { this.setState({isLiveYoutube: isLive})}
    setYoutubeDuration = (duration: string | number) => { this.setState({youtubeDuration: duration})}

    saveYoutube = async () =>{
        let isValid = true;
        if(!this.state.youtubeName) { this.setState({isYoutubeNameError : true}); isValid = false; }
        if(!this.state.youtubeUrl) { this.setState({isYoutubeUrlError : true}); isValid = false; }

        if(!isValid) return

        let request:YoutubeMediaRequest = {
            name: this.state.youtubeName,
            url: this.state.youtubeUrl,
            isLive: this.state.isLiveYoutube,
            duration: +this.state.youtubeDuration,
            taxonomiesCategoryId: this.state.selectedMediaCategory ? this.state.selectedMediaCategory.value : null
        }

        this.setState({isUploading: true});
        let result = await postYoutubeMedia(request);
        if(result.type === "succes"){
            this.closeYoutubeModal();
            this.setState({ youtubeName: '', youtubeUrl: '', isLiveYoutube: false, youtubeDuration: 15})
            await this.updateMediaList();
        }
        this.setState({isUploading: false});
    }

    saveVastUrl = async () => {
        let isValid = true;
        if(!this.state.vastName) { this.setState({isVastNameError : true}); isValid = false; }
        if(!this.state.vastUrl) { this.setState({isVastUrlError : true}); isValid = false; }

        if(!isValid) return
        this.setState({isUploading: true});
        let request: MediaVastRequest = { 
            name: this.state.vastName, 
            url: this.state.vastUrl, 
            contentType: this.state.selectedContentTypeOption!.type,
            clockID: this.state.clockId,
            taxonomiesCategoryId: this.state.selectedMediaCategory ? this.state.selectedMediaCategory.value : null
        }
        let result
        if(!!this.state.vastIdForUpdate) {
            result = await updateMediaVast( this.state.vastIdForUpdate, request);
        } else {
            result = await postMediaVast(request);
        }
        if(result.type == "succes") {
            this.closeVASTModal();
            this.setState({vastName:'',vastUrl:'', vastIdForUpdate:'', clockId:''})
            await this.updateMediaList();
        }
        this.setState({isUploading:false})
    }

    showWebPageModal = () => { this.setState({showWebPageModal: true})};
    closeWebPageModal = () => { 
        this.setState({
            webPageIdForUpdate: "",
            showWebPageModal: false, 
            isWebPageNameError:false, 
            isWebPageUrlError: false,
            webPageName: "",
            webPageUrl:"",
            zipFile: null,
            isWebPageZipError: false,
            isLocal: true,
            selectedWebPageType: WebPageType.URL,
            webPageDuration: 15,
            selectedWebPageContentTypeOption: mediaContentTypeOptions[0],
            webPageClockId: "",
            selectedMediaCategory: null
        })
    };
    setWebPageName = (newName: string) => { this.setState({webPageName: newName, isWebPageNameError: false})}
    setWebPageUrl = (newUrl: string) => { this.setState({webPageUrl: newUrl, isWebPageUrlError: false})}
    setWebPageDuration = (duration: string | number) => { this.setState({webPageDuration: duration})}
    setWebPageClockId = (clockId:string) => {this.setState({webPageClockId: clockId})}
    onSelectedWebPageContentType = (newValue: SingleValue<MediaContentTypeOption>) => {
        this.setState({ selectedWebPageContentTypeOption: newValue})
    }

    onChangeWebPageType = (value: WebPageType) => {
        this.setState({ selectedWebPageType: value, zipFile:null, webPageUrl: "", isWebPageUrlError: false, isWebPageZipError: false });
    };

    onUploadZipArchieve = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.files){
            this.setState({zipFile: event.target.files[0], isWebPageZipError: false})
        };
    }

    saveWebPage = async () => {
        let isValid = true;
        if(!this.state.webPageName) { this.setState({isWebPageNameError : true}); isValid = false; }
        if(!this.state.webPageUrl && this.checkSelectedWebPageType(WebPageType.URL)) { this.setState({isWebPageUrlError : true}); isValid = false; }
        if(!this.state.zipFile && this.checkSelectedWebPageType(WebPageType.ZIP) && !this.state.webPageIdForUpdate) { this.setState({isWebPageZipError : true}); isValid = false; }

        if(!isValid) return
        this.setState({isUploading: true});
        let request: WebPageRequest = { 
            name: this.state.webPageName, 
            url: this.state.webPageUrl, 
            zipFile: this.state.zipFile,
            isLocal: this.state.isLocal,
            webPageType: this.state.selectedWebPageType,
            contentType: this.state.selectedWebPageContentTypeOption!.type,
            durationSeconds: +this.state.webPageDuration,
            clockID: this.state.webPageClockId,
            taxonomiesCategoryId: this.state.selectedMediaCategory ? this.state.selectedMediaCategory.value : null
        }
        let result
        if(!!this.state.webPageIdForUpdate) {
            result = await updateWebPage( this.state.webPageIdForUpdate, request);
        } else {
            // result = await postWebPage(request);
            result = await postWebPageWithZip(request);
        }
        if(result.type == "succes") {
            this.closeWebPageModal();
            await this.updateMediaList();
        }
        this.setState({isUploading:false})
    }

    showEditWebPageModal = (webpage: MediaModel) => {
        this.setState({
            showWebPageModal: true,
            webPageIdForUpdate: webpage.id,
            webPageName: webpage.name,
            webPageUrl: webpage.url,
            selectedWebPageContentTypeOption: mediaContentTypeOptions.filter(it => it.type === webpage.contentType)[0],
            webPageDuration: webpage.durationMs / 1000,
            webPageClockId: webpage.clockId,
            isLocal: webpage.webPageIsDownloadLocaly,
            zipFile: null,
            selectedWebPageType: webpage.webPageType,
            selectedMediaCategory:this.getCategoryById(webpage.taxonomiesCategoryId) 
        })
    }

    showHiveStackModal = () => { this.setState({showHiveStackModal: true})};
    closeHiveStackModal = () => { 
        this.setState({
            hiveStackIdForUpdate: "",
            showHiveStackModal: false, 
            isHiveStackNameError:false, 
            hiveStackName: "",
            selectedHiveStackContentTypeOption: mediaContentTypeOptions[0],
            hiveStackClockId: "",
            selectedMediaCategory: null
        })
    };

    showEditHiveStackModal = (hivestack: MediaModel) => {
        this.setState({
            showHiveStackModal: true,
            hiveStackIdForUpdate: hivestack.id,
            hiveStackName: hivestack.name,
            selectedWebPageContentTypeOption: mediaContentTypeOptions.filter(it => it.type === hivestack.contentType)[0],
            hiveStackClockId: hivestack.clockId,
            selectedMediaCategory: this.getCategoryById(hivestack.taxonomiesCategoryId) 
        })
    }

    getCategoryById = (id: number | null) => {
        if (id == null) return null;
        return this.state.mediaCategories.find(it => it.value === id) || null;
    }

    onSelectedHiveStackContentType = (newValue: SingleValue<MediaContentTypeOption>) => {
        this.setState({ selectedHiveStackContentTypeOption: newValue})
    }

    setHiveStackName = (newName: string) => { this.setState({hiveStackName: newName, isHiveStackNameError: false})}
    setHiveStackClockId = (clockId:string) => {this.setState({hiveStackClockId: clockId})}

    saveHiveStack = async () => {
        let isValid = true;
        if(!this.state.hiveStackName) { this.setState({isHiveStackNameError : true}); isValid = false; }

        if(!isValid) return
        this.setState({isUploading: true});
        let request: HiveStackRequest = { 
            name: this.state.hiveStackName, 
            contentType: this.state.selectedHiveStackContentTypeOption!.type,
            clockID: this.state.hiveStackClockId,
            taxonomiesCategoryId: this.state.selectedMediaCategory ? this.state.selectedMediaCategory.value : null
        }

        let result
        if(!!this.state.hiveStackIdForUpdate) {
            result = await updateHiveStack( this.state.hiveStackIdForUpdate, request);
        } else {
            result = await postHiveStack(request);
        }
        if(result.type == "succes") {
            this.closeHiveStackModal();
            await this.updateMediaList();
        }
        this.setState({isUploading:false})
    }

    hideDatefilterDropdown = () => {
        this.setState({isDatefilterDropdownShow:false})
    }

    toggleDatefilterDropdown = (event?:React.MouseEvent) => {
        if(event) event.stopPropagation();
        this.setState({isDatefilterDropdownShow: !this.state.isDatefilterDropdownShow})
    }

    setStartDatePeriod = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            isPeriodStartError: false,
            periodStart : moment(event.target.value),
            currentFilterPeriod: ''
        });
    }
    
    setEndDatePeriod = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            isPeriodEndError: false,
            periodEnd : moment(event.target.value),
            currentFilterPeriod: ''
        });
    }

    showMediaDeleteModal = (id:Guid, mediaName: string) =>{
        this.setState({
            showMediaDeleteModal:true,
            mediaIdForAction: id,
            mediaNameForDelete: mediaName,
        })
    }

    closeMediaDeleteModal = () =>{
        this.setState({
            showMediaDeleteModal:false,
            mediaIdForAction: '',
            mediaNameForDelete: '',
        })
    }

    confirmMediaDelete = async () => {
        this.setState({isUploading:true});
        await this.deleteMedia(this.state.mediaIdForAction);
        this.closeMediaDeleteModal();
        this.setState({isUploading:false})
    }

    deleteMedia = async (id: Guid) => {
        this.setState({isUploading:true});
        let result = await deleteMedia(id);
        if(result.type == "succes"){
            await this.updateMediaList();
        }
        this.setState({isUploading: false})
    }

    renderMediaType = (media: MediaModel) => {
        switch(media.mediaType){
            case MediaType.Image : return `Image (${media.sizeMb}MB)`;
            case MediaType.Video : return `Video (${media.sizeMb}MB)`;
            case MediaType.VastUrl : return "VAST Url";
            case MediaType.Youtube : return "Youtube";
            case MediaType.YoutubeLive : return "Youtube Live";
            case MediaType.WebPage : return "Web Page";
            case MediaType.HiveStack : return "Hivestack";
        }
    }

    renderMediaTypePreview = (media: MediaModel) => {
        switch(media.mediaType){
            case MediaType.Image : return <img className="media-img" src={media.previewLink} alt="" />;
            case MediaType.Video : return <img className="media-img" src={media.previewLink} alt="" />;
            case MediaType.VastUrl : return <SvgSelector title="url" />;
            case MediaType.Youtube : return <img className="media-img" src={media.previewLink} alt="" />;
            case MediaType.YoutubeLive : return <img className="media-img" src={media.previewLink} alt="" />;
            case MediaType.WebPage : return <SvgSelector title="webview" />;
            case MediaType.HiveStack : return <img className="media-img" src={hiveStackIMG} alt="" />;
        }
    }

    renderMediaTypeLink = (media: MediaModel) => {
        switch(media.mediaType){
            case MediaType.Image : return <span className="file-name" onClick={() => {this.showMediaInfoModal(media)}}>{media.name}</span>;
            case MediaType.Video : return <span className="file-name" onClick={() => {this.showMediaInfoModal(media)}}>{media.name}</span>;
            case MediaType.VastUrl : return <span className="file-name" onClick={() => {this.showEditVastModal(media)}}>{media.name}</span>;
            case MediaType.Youtube : return <span className="file-name" onClick={() => {this.showMediaInfoModal(media)}}>{media.name}</span>;
            case MediaType.YoutubeLive : return <span className="file-name" onClick={() => {this.showMediaInfoModal(media)}}>{media.name}</span>;
            case MediaType.WebPage : return <span className="file-name" onClick={() => {this.showEditWebPageModal(media)}}>{media.name}</span>;
            case MediaType.HiveStack : return <span className="file-name" onClick={() => {this.showEditHiveStackModal(media)}}>{media.name}</span>;
        }
    }

    renderContentType(contentType:MediaContentType){
        switch(contentType){
            case MediaContentType.Ads: return mediaContentTypeOptions[0].name;
            case MediaContentType.ClientContent: return mediaContentTypeOptions[1].name;
            case MediaContentType.SelfContent: return mediaContentTypeOptions[2].name;
            case MediaContentType.Backup: return mediaContentTypeOptions[3].name;
        }
    }

    getCurrentPlayout(id: Guid){
        let t = this.state.playouts.find(it => it.mediaId === id);
        if(!t){
            return "Loading"
        }
        return t.count
    }

    renderRow(media: MediaModel, index:number){
        return <tr key={media.id}>
            <td>
                {this.renderMediaTypePreview(media)}
            </td>
            <td>
                {this.renderMediaTypeLink(media)}
            </td>
            <td>
                {media.campaigns.map((it, i) => <p key={i}>{it.name}</p>)}
            </td>
            <td>
                {this.renderMediaType(media)}
            </td>
            <td>
                {formatDate(media.uploadTime)}
            </td>
            <td>
                {this.renderContentType(media.contentType)}
            </td>
            <td>
                {this.getCurrentPlayout(media.id)}
            </td>
            <td>
                <div className="d-flex align-items-center justify-content-end">
                {media.mediaType === MediaType.Video && <IconButton tooltipText="Transcode" type="dolby" onClick={()=>this.showTranscodeModal(media.id)}/>}
                <IconButton tooltipText="Delete" type="delete" onClick={() => {this.showMediaDeleteModal(media.id, media.name)}}/>
                </div>
            </td>
        </tr>
    }

    renderActiveFilterIcon = () => {
        return <span className="active-filter">
            <SvgSelector title="ok" />
        </span>
    }

    showTranscodeModal = (id:Guid) => {
        this.setState({
            mediaIdForAction: id,
            isShowTranscodeModal: true,
        })
    }

    hideTranscodeModal = () => {
        this.setState({
            isShowTranscodeModal: false,
            mediaIdForAction:""
        })
    }

    checkFilterDateForInput = (date: Moment | undefined) => {
        if(!!date) {
            return moment(date).format('YYYY-MM-DD')
        }
        return ''
    }

    checkSelectedWebPageType = (type: WebPageType) => type === this.state.selectedWebPageType

    checkIsVisibleBlockByWebPageType = (type: WebPageType) => {
        if(this.state.webPageIdForUpdate){
            return this.checkSelectedWebPageType(type)
        } 
    }

    onChangeSelectedMediaCategory = (newValue: SingleValue<Option<number>>) => {
        this.setState({selectedMediaCategory: newValue})
    }

    render(): JSX.Element {
        return <InnerLayout 
                    activeTab="media" 
                    logOut={this.props.logOut} 
                    toogleCollapse={this.props.toogleCollapse}
                    isCollapsed={this.props.isCollapsed}>
            
                <div>
                        <GlobalSpinner isShow={this.state.isUploading}/>
                        <div className="d-flex justify-content-between align-items-center mb-20 pt-50">
                            <Search value={this.state.searchString} onChangeValue={this.setSearchString}/>
                            <div className="d-flex">
                                <Button color="green" label="Add Hivestack" onClick={this.showHiveStackModal} />&nbsp;
                                <Button color="green" label="Add Web Page" onClick={this.showWebPageModal} />&nbsp;
                                <Button color="green" label="Add Youtube" onClick={this.showYoutubeModal} />&nbsp;
                                <Button color="green" label="Add VAST" onClick={this.showVASTModal} />&nbsp;
                                <SelectMultipleFileButton title="Add Media" onMediaUploaded={this.updateMediaList} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-end mb-20 ">
                            <div className="media-filter__row">
                                <div className="media-filter__block">
                                    <label>Campaigns</label>
                                    <Select 
                                        options={this.state.campaigns}
                                        isMulti
                                        classNamePrefix={`select`}
                                        onChange={this.onChangeSelectedCampaigns} 
                                    /> 
                                </div>
                            </div>
                            <div className="d-flex align-items-center export-block mb-10">
                                <DropdownBlock title={<IconButton tooltipText="Filter" type="filter"/>} isRightPosition={true}>
                                    <FormRow>
                                        <label htmlFor="start">From</label>
                                        <input 
                                            type="date" 
                                            className={`form-control ${this.state.isPeriodStartError ? "error" : ""}`}  
                                            name="" 
                                            id="start" 
                                            onChange={this.setStartDatePeriod}
                                            value={this.checkFilterDateForInput(this.state.periodStart)}
                                        />
                                    </FormRow>
                                    <FormRow>
                                        <label htmlFor="end">To</label>
                                        <input 
                                            type="date" 
                                            className={`form-control ${this.state.isPeriodEndError ? "error" : ""}`}  
                                            name="" 
                                            id="end" 
                                            onChange={this.setEndDatePeriod}
                                            value={this.checkFilterDateForInput(this.state.periodEnd)}
                                        />
                                    </FormRow>
                                    <div className="date-constants">
                                        <span 
                                            className={this.checkCurrentFilterPeriod(FilterDatesType.All) ? 'active' : ''} 
                                            onClick={()=> this.setFilterPeriod(FilterDatesType.All)}
                                        >
                                            {this.checkCurrentFilterPeriod(FilterDatesType.All) && this.renderActiveFilterIcon()}
                                            <span className="filter-text">All</span>
                                        </span>
                                        <span 
                                            className={this.checkCurrentFilterPeriod(FilterDatesType.Yesterday) ? 'active' : ''}
                                            onClick={()=> this.setFilterPeriod(FilterDatesType.Yesterday)}
                                        >
                                            {this.checkCurrentFilterPeriod(FilterDatesType.Yesterday) && this.renderActiveFilterIcon()}
                                            <span className="filter-text">Yesterday</span>
                                        </span>
                                        <span
                                            className={this.checkCurrentFilterPeriod(FilterDatesType.Today) ? 'active' : ''}
                                            onClick={()=> this.setFilterPeriod(FilterDatesType.Today)}
                                        >
                                            {this.checkCurrentFilterPeriod(FilterDatesType.Today) && this.renderActiveFilterIcon()}
                                            <span className="filter-text">Today</span>
                                        </span>
                                        <span
                                            className={this.checkCurrentFilterPeriod(FilterDatesType.Last7Days) ? 'active' : ''}
                                            onClick={()=> this.setFilterPeriod(FilterDatesType.Last7Days)}
                                        >
                                            {this.checkCurrentFilterPeriod(FilterDatesType.Last7Days) && this.renderActiveFilterIcon()}
                                            <span className="filter-text">Last 7 days</span>
                                        </span>
                                        <span
                                            className={this.checkCurrentFilterPeriod(FilterDatesType.Last30Days) ? 'active' : ''}
                                            onClick={()=> this.setFilterPeriod(FilterDatesType.Last30Days)}
                                        >
                                            {this.checkCurrentFilterPeriod(FilterDatesType.Last30Days) && this.renderActiveFilterIcon()}
                                            <span className="filter-text">Last 30 days</span>
                                        </span>
                                    </div>
                                </DropdownBlock>
                            </div>
                        </div>
                        <table className="table media-table">
                            <thead>
                                <tr>
                                    <td></td>
                                    <td>File Name</td>
                                    <td>Campaign Name</td>
                                    <td>Media Type</td>
                                    <td>Uploaded </td>
                                    <td>Content Type</td>
                                    <td>Playouts</td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                {!!this.state.media.length && this.state.media.map((m, i) => this.renderRow(m, i)) }
                            </tbody>
                        </table> 
                        {!!this.state.media.length && <Pagination 
                            activePage={this.state.currentPage} 
                            pagesCount={this.state.totalPages} 
                            changePaginationPage={this.changePaginationPage} 
                            aroundElements={2}
                        />}
                        
                    <CenterModal title="Media info" show={this.state.showMediaInfoModal} onRequestClose={this.closeMediaInfoModal}>
                        {this.state.mediaInfo ? <FileInfo 
                            mode="edit" 
                            mediaInfo={this.state.mediaInfo} 
                            mediaCategories={this.state.mediaCategories}
                            onUpdateMediaInfo={this.onUpdateMediaInfo}
                        /> : 
                        <h1>Media info is undefined</h1>
                        }
                    </CenterModal>   
                    <RightModal title="VAST" show={this.state.showVASTModal} onRequestClose={this.closeVASTModal}>
                        <FormRow>
                            <FormInput 
                                title="Name" 
                                id="name-id"
                                value={this.state.vastName} 
                                isError={this.state.isVastNameError} 
                                errorMessage="Invalid vast name" 
                                onChange={()=>{}} 
                                onChangeValue={this.setVastName} 
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                title="URL" 
                                id="url-id" 
                                value={this.state.vastUrl} 
                                isError={this.state.isVastUrlError} 
                                errorMessage="Invalid vast url" 
                                onChange={()=>{}} 
                                onChangeValue={this.setVastUrl} 
                            />
                        </FormRow>
                        <FormRow>
                            <label>Content Type</label>
                            <Select
                                className={`w-100`}
                                classNamePrefix={`select`}
                                options={mediaContentTypeOptions}
                                filterOption={(option, input) => option.label.toLowerCase().includes(input.toLowerCase())}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option) => `${option.type}`}
                                onChange={this.onSelectedMediaLabel}
                                value={this.state.selectedContentTypeOption}
                                isMulti={false}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                title="Clock ID" 
                                id="clock-id"
                                value={this.state.clockId} 
                                isError={false} 
                                errorMessage="" 
                                onChange={()=>{}} 
                                onChangeValue={this.setClockID} 
                            />
                        </FormRow>
                        <FormRow>
                            <label>Media Category</label>
                            <Select
                                className={`w-100`}
                                classNamePrefix={`select`}
                                options={this.state.mediaCategories}
                                onChange={this.onChangeSelectedMediaCategory}
                                value={this.state.selectedMediaCategory}
                                isMulti={false}
                                isClearable
                            />
                        </FormRow>
                        <div className="modal-btn-group">
                            <Button color="green" label="Save" onClick={this.saveVastUrl}/>
                            <Button color="gray" label="Cancel" onClick={this.closeVASTModal}/>
                        </div>
                    </RightModal>   
                    <RightModal title="Youtube" show={this.state.showYoutubeModal} onRequestClose={this.closeYoutubeModal}>
                        <FormRow>
                            <FormInput 
                                title="Name" 
                                id="name-id"
                                value={this.state.youtubeName} 
                                isError={this.state.isYoutubeNameError} 
                                errorMessage="Invalid youtube name" 
                                onChange={()=>{}} 
                                onChangeValue={this.setYoutubeName} 
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                title="URL" 
                                id="url-id" 
                                value={this.state.youtubeUrl} 
                                isError={this.state.isYoutubeUrlError} 
                                errorMessage="Invalid youtube url" 
                                onChange={()=>{}} 
                                onChangeValue={this.setYoutubeUrl} 
                            />
                        </FormRow>
                        <FormRow>
                            <div className="d-flex align-items-center">
                                <FormCheckbox id="youtube-live" checked={this.state.isLiveYoutube} onChange={this.setYoutubeLive} />
                                <span className="status-block">
                                    {this.state.isLiveYoutube ? <span className="current-status online">&nbsp;Live</span> : <span className="current-status offline">&nbsp;Live</span>}
                                </span>
                            </div>
                        </FormRow>
                        <FormRow>
                            <FormInputNumber 
                                id="youtube-duration"
                                title="Duration (seconds)"
                                isError={false}
                                errorMessage=""
                                onChangeValue={value => {
                                    if(value === "" || +value < 0 ) this.setYoutubeDuration('')
                                    else this.setYoutubeDuration(+value)
                                }}
                                onChange={()=>{}}
                                value={this.state.youtubeDuration}
                            />
                        </FormRow>
                        <FormRow>
                            <label>Media Category</label>
                            <Select
                                className={`w-100`}
                                classNamePrefix={`select`}
                                options={this.state.mediaCategories}
                                onChange={this.onChangeSelectedMediaCategory}
                                value={this.state.selectedMediaCategory}
                                isMulti={false}
                                isClearable
                            />
                        </FormRow>
                        <div className="modal-btn-group">
                            <Button color="green" label="Save" onClick={this.saveYoutube}/>
                            <Button color="gray" label="Cancel" onClick={this.closeYoutubeModal}/>
                        </div>
                    </RightModal>  

                    <RightModal title="Web Page" show={this.state.showWebPageModal} onRequestClose={this.closeWebPageModal}>
                        <FormRow>
                            <FormInput 
                                title="Name" 
                                id="webpage-name-id"
                                value={this.state.webPageName} 
                                isError={this.state.isWebPageNameError} 
                                errorMessage="Invalid Web Page name" 
                                onChange={()=>{}} 
                                onChangeValue={this.setWebPageName} 
                            />
                        </FormRow>
                        <FormRow>
                            <div className="d-flex gap15">
                            <label>
                                <input
                                    type="radio"
                                    name="webPageType"
                                    value={WebPageType.URL}
                                    checked={this.state.selectedWebPageType === WebPageType.URL}
                                    onChange={() => this.onChangeWebPageType(WebPageType.URL)}
                                    disabled={!!this.state.webPageIdForUpdate}
                                />&nbsp;
                                URL
                            </label>

                            <label>
                                <input
                                    type="radio"
                                    name="webPageType"
                                    value={WebPageType.ZIP}
                                    checked={this.state.selectedWebPageType === WebPageType.ZIP}
                                    onChange={() => this.onChangeWebPageType(WebPageType.ZIP)}
                                    disabled={!!this.state.webPageIdForUpdate}
                                />&nbsp;
                                ZIP
                            </label>
                            </div>
                        </FormRow>
                        { this.checkSelectedWebPageType(WebPageType.URL) && <FormRow>
                            <FormInput 
                                title="URL" 
                                id="webpage-url-id" 
                                value={this.state.webPageUrl} 
                                isError={this.state.isWebPageUrlError} 
                                errorMessage="Invalid Web Page url" 
                                onChange={()=>{}} 
                                onChangeValue={this.setWebPageUrl} 
                            />
                        </FormRow>}
                        { this.checkSelectedWebPageType(WebPageType.ZIP) && <FormRow>
                            {!this.state.webPageIdForUpdate && <>
                                <label htmlFor="zip-upload" className="btn primary_btn">Upload Zip</label>
                                <input id="zip-upload" type="file" name="zip-upload" accept=".zip" onChange={this.onUploadZipArchieve}/>
                            </>}
                            {this.state.isWebPageZipError && <span className="error">Please select FILE</span>}
                            {this.state.zipFile?.name && <p className="mb-20">Selected File: {this.state.zipFile?.name}</p>}
                            <div className="d-flex align-items-center">
                                <FormCheckbox id="download-locally" checked={this.state.isLocal} onChange={()=>{}} isDisabled={true} />
                                <span className="status-block">
                                    {this.state.isLocal ? <span className="current-status online">&nbsp;Download locally </span> 
                                    : <span className="current-status offline">&nbsp;Download locally</span>}
                                </span>
                            </div>
                        </FormRow>}
                        <FormRow>
                            <label>Content Type</label>
                            <Select
                                className={`w-100`}
                                classNamePrefix={`select`}
                                options={mediaContentTypeOptions}
                                filterOption={(option, input) => option.label.toLowerCase().includes(input.toLowerCase())}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option) => `${option.type}`}
                                onChange={this.onSelectedWebPageContentType}
                                value={this.state.selectedWebPageContentTypeOption}
                                isMulti={false}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInputNumber 
                                id="webpage-duration"
                                title="Duration (seconds)"
                                isError={false}
                                errorMessage=""
                                onChangeValue={value => {
                                    if(value === "" || +value < 0 ) this.setWebPageDuration('')
                                    else this.setWebPageDuration(+value)
                                }}
                                onChange={()=>{}}
                                value={this.state.webPageDuration}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                title="Clock ID" 
                                id="webpage-clock-id"
                                value={this.state.webPageClockId} 
                                isError={false} 
                                errorMessage="" 
                                onChange={()=>{}} 
                                onChangeValue={this.setWebPageClockId} 
                            />
                        </FormRow>
                        <FormRow>
                            <label>Media Category</label>
                            <Select
                                className={`w-100`}
                                classNamePrefix={`select`}
                                options={this.state.mediaCategories}
                                onChange={this.onChangeSelectedMediaCategory}
                                value={this.state.selectedMediaCategory}
                                isMulti={false}
                                isClearable
                            />
                        </FormRow>
                        <div className="modal-btn-group">
                            <Button color="green" label="Save" onClick={this.saveWebPage}/>
                            <Button color="gray" label="Cancel" onClick={this.closeWebPageModal}/>
                        </div>
                    </RightModal>  

                    <RightModal title="Hivestack" show={this.state.showHiveStackModal} onRequestClose={this.closeHiveStackModal}>
                        <FormRow>
                            <FormInput 
                                title="Name" 
                                id="hivestack-name-id"
                                value={this.state.hiveStackName} 
                                isError={this.state.isHiveStackNameError} 
                                errorMessage="Invalid Hivestack name" 
                                onChange={()=>{}} 
                                onChangeValue={this.setHiveStackName} 
                            />
                        </FormRow>
                        <FormRow>
                            <label>Content Type</label>
                            <Select
                                className={`w-100`}
                                classNamePrefix={`select`}
                                options={mediaContentTypeOptions}
                                filterOption={(option, input) => option.label.toLowerCase().includes(input.toLowerCase())}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option) => `${option.type}`}
                                onChange={this.onSelectedHiveStackContentType}
                                value={this.state.selectedHiveStackContentTypeOption}
                                isMulti={false}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                title="Clock ID" 
                                id="hivestack-clock-id"
                                value={this.state.hiveStackClockId} 
                                isError={false} 
                                errorMessage="" 
                                onChange={()=>{}} 
                                onChangeValue={this.setHiveStackClockId} 
                            />
                        </FormRow>
                        <FormRow>
                            <label>Media Category</label>
                            <Select
                                className={`w-100`}
                                classNamePrefix={`select`}
                                options={this.state.mediaCategories}
                                onChange={this.onChangeSelectedMediaCategory}
                                value={this.state.selectedMediaCategory}
                                isMulti={false}
                                isClearable
                            />
                        </FormRow>
                        <div className="modal-btn-group">
                            <Button color="green" label="Save" onClick={this.saveHiveStack}/>
                            <Button color="gray" label="Cancel" onClick={this.closeHiveStackModal}/>
                        </div>
                    </RightModal>  

                    <MediaTranscodeModal 
                        id={this.state.mediaIdForAction} 
                        isShow={this.state.isShowTranscodeModal} 
                        closeHandler={this.hideTranscodeModal} 
                        loadingHandler={this.setIsUploading}
                    />
                    
                    <SmallModal show={this.state.showMediaDeleteModal} onRequestClose={this.closeMediaDeleteModal}> 
                        <p>That you want to delete media <b>{this.state.mediaNameForDelete}</b>?</p>
                        <div className="modal-btn-group">
                            <Button color="gray" label="Cancel" onClick={this.closeMediaDeleteModal}/>
                            <Button color="green" label="Yes" onClick={this.confirmMediaDelete}/>
                        </div>
                    </SmallModal>
                </div>
                
               </InnerLayout>
    }
}

export default withRouter(Media);